module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-icon-music-a5cdc9637f49e31bc7a43ecc434facc4.png";